import {
  GETTING_COMMENTS,
  GOT_COMMENTS,
  GOT_MORE_COMMENTS
} from "./actionTypes";
import changeKey from "./keyAction";
import yangAxios from "../YangAxios";

export const getComments = (videoId, params = "") => {
  return async (dispatch, getStore) => {
    dispatch(gettingComments(true));
    const keys = getStore().apiKey.keys;
    let index = getStore().apiKey.currentKey;
    try {
      let res = await yangAxios(
        `commentThreads?part=${encodeURI(
          "snippet,replies"
        )}&videoId=${videoId}&order=relevance&maxResults=20${params}&key=${
          keys[index]
        }`
      );
      res = res.data;

      if (params.indexOf("&pageToken") !== -1) dispatch(gotMoreComments(res));
      else dispatch(gotComments(res));
    } catch (err) {
      if (index < keys.length && err.response && err.response.status === 403) {
        index++;
        dispatch(changeKey(index));
        dispatch(getComments(videoId, params));
      }
      console.log(err);
    }
    dispatch(gettingComments(false));
  };
};

const gettingComments = val => {
  return {
    type: GETTING_COMMENTS,
    payload: val
  };
};

const gotComments = data => {
  return {
    type: GOT_COMMENTS,
    payload: data
  };
};

const gotMoreComments = data => {
  return {
    type: GOT_MORE_COMMENTS,
    payload: data
  };
};
